import { Reveal } from "../Reveal";
import { Leaf } from "./JMarquee";

const PILLARS = [
  ["01", "Genéticas estudiadas por IA", "Una potente herramienta de IA ha estudiado la mayoría de genéticas de cannabis para cubrir sus necesidades nutricionales en cada fase."],
  ["02", "Tecnología Efecto CO2", "Optimiza los procesos metabólicos y la fotosíntesis: plantas más fuertes, follaje verde intenso y estructura robusta."],
  ["03", "Efecto Buffer", "Componentes que ajustan el pH para asegurar la disponibilidad de los nutrientes en todo momento, sin ácidos ni bases."],
  ["04", "Menos sales, mejor final", "Análisis comparativo de las mejores opciones del mercado para no sobrecargar la solución: acabados más rápidos y limpios."],
];

export const JTech = () => (
  <section id="tecnologia" data-testid="technology-section" className="relative py-24 md:py-36 bg-blue-leaves overflow-hidden">
    <div className="absolute inset-0 bg-[#1B3A8C]/55" />
    <img src="/img/leaves-left.webp" alt="" aria-hidden="true" className="pointer-events-none absolute -left-32 -bottom-10 w-[260px] md:w-[300px] opacity-70" />
    <div className="relative max-w-[1400px] mx-auto px-5 md:px-10 grid lg:grid-cols-12 gap-12">
      <div className="lg:col-span-5">
        <Reveal className="lg:sticky lg:top-28">
          <p className="font-mono-d text-[11px] tracking-[0.22em] uppercase text-[#F2B441] mb-6">Tecnología</p>
          <h2 className="font-serif-d font-black text-5xl md:text-6xl leading-[0.92] tracking-tight">
            La IA aprende de la selva. <span className="italic font-semibold text-[#F2B441]">Tu planta lo nota.</span>
          </h2>
          <p className="text-[#E3EADF] mt-6 leading-relaxed max-w-md">Biotecnología avanzada optimizada por Inteligencia Artificial, fabricada en Granada por Savi Nutri Tech.</p>
        </Reveal>
      </div>
      <div className="lg:col-span-7 grid sm:grid-cols-2 gap-4">
        {PILLARS.map(([n, t, b], i) => (
          <Reveal key={n} delay={(i % 2) * 0.1}>
            <div data-testid={`tech-pillar-${n}`} className="group h-full rounded-[10px] bg-[#0E2A1C]/90 backdrop-blur-md border border-[#F6EEDC]/20 p-7 hover:border-[#F2B441] transition-colors duration-500">
              <div className="flex items-center justify-between">
                <span className="font-label text-5xl text-label-gold">{n}</span>
                <Leaf className="w-6 h-6 text-[#8CD05A] transition-transform duration-700 group-hover:rotate-[20deg]" />
              </div>
              <h3 className="text-xl font-bold tracking-tight mt-6">{t}</h3>
              <p className="text-[#C9D6C2] mt-3 leading-relaxed text-sm">{b}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
